export default __webpack_public_path__ + "static/media/math.9bf17c32.svg";